import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-radio',
  templateUrl: './custom-radio.component.html',
  styleUrls: ['./custom-radio.component.scss'],
})
export class CustomRadioComponent {
  @Input('data') data!: any[];
  @Input() scroll: false | number = false;
  @Input('text') text: string = 'text';
  @Input() currentValue!: any;
  @Output() currentValueChange: EventEmitter<any> = new EventEmitter<any>();
  name = Math.random().toString();

  

  select(item: any) {
    this.currentValue = item;
    this.currentValueChange.emit(item);
  }
}
